


















































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { get_agency_invoice_detail } from '@/api/invoice';
import { list_product_summaries } from '@/api/product';
import { formatTime } from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';
import { CurrencyEnum } from '@/api/types';

@Component({
  name: 'InvoiceAgencyDetailReport',
  components: {},
})
export default class extends Vue {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ required: true })
  report!: get_agency_invoice_detail.AgencySalesReport;
  @Prop({ required: true }) products!: Map<
    string,
    list_product_summaries.Product
  >;
  private realTickets: get_agency_invoice_detail.Product[] = [];

  get isMobile() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  get hideRealTickets() {
    return this.realTickets.length <= 0;
  }

  get totalCurrency() {
    if (this.report && this.report.currency) {
      return this.report.currency;
    }
    return CurrencyEnum.JPY;
  }

  get totalPrice() {
    if (this.report && this.report.totalNetPrice !== void 0) {
      return this.report.totalNetPrice;
    }
    return 0;
  }

  mounted() {
    this.loadRealTickets();
  }

  private loadRealTickets() {
    let realTickets: get_agency_invoice_detail.Product[] = [];
    if (this.report && this.report.products) {
      realTickets = this.report.products;
    }
    this.realTickets = realTickets;
  }

  private getReportedAtText(reportedAt: string) {
    return formatTime(new Date(reportedAt));
  }

  private getProductNameText(item: get_agency_invoice_detail.Product) {
    return `${
      this.$i18n.locale !== 'ja' &&
      this.products.has(item.productId) &&
      this.products.get(item.productId)!.nameEn
        ? this.products.get(item.productId)!.nameEn
        : item.productName
    }${
      this.products.get(item.productId)!.fiscalYear === 0
        ? ''
        : ' [' + this.products.get(item.productId)!.fiscalYear + ']'
    }`;
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
